/* tslint:disable:jsx-no-lambda */
import React from "react";
import classNames from "classnames";
import { BrowserView, MobileView } from "react-device-detect";
import Layout from "antd/es/layout";
import { connect } from "react-redux";

import { RootState } from "src/ipm-shared/store/model/reducers";
import * as selectors from "src/bepaid/store/model/Fetch/selectors";
import FeatureGateUtil from "src/ipm-shared/components/FeatureGating/Util";

import TitleHeading from "./components/TitleHeading";
import Menu from "../Menu";
import AccountPendingReviewBanner from "src/bepaid/components/AccountPendingReviewBanner";

import styles from "./MainLayout.module.scss";

const MainLayout: React.FC<any> = (props: any) => {
  const {
    children,
    header: {
      title = null,
      subTitle = null,
      onBack = null,
      onClose = null,
      onFavouriteAction = null,
      isFavourite = null,
      rightIcons = null,
      hideMenu = false,
      center = false,
      progress = null,
      hasBorder = true,
      leftHeader = null, // desktop
      rightHeader = null // desktop
    } = {},
    body: {
      leftBody = null, // desktop
      rightBody = null, // desktop
      fullBody = null
    } = {},
    footer = null,
    usingModal = false,
    id,
    fullContent = false,
    banner = null,
    isAccountPendingReview = false,
    showEmailSuggestionBanner = false,
    features = 0,
    hideBanner = false,
    hasToken = false
  } = props;

  const isInactiveAccount =
    hasToken &&
    !FeatureGateUtil.verifyFeature(features, "NORMAL_PAYMENT") &&
    !isAccountPendingReview;

  React.useEffect(() => {
    try {
      (window as any).Intercom("update");
    } catch (e) {
      window.Logger.guestError("Intercom update failed: " + e.toString());
    }
  }, []);

  const renderBanner = () => {
    if (isInactiveAccount) {
      return <AccountPendingReviewBanner inactive={true} />;
    }
    if (isAccountPendingReview) {
      return (
        <AccountPendingReviewBanner
          emailSuggestion={showEmailSuggestionBanner}
        />
      );
    }
    if (banner) {
      return <div className={styles.bannerContainer}>{banner}</div>;
    }
    return null;
  };

  const renderDesktopView = () => {
    return (
      <div id={id} className={classNames(styles.wrapper, styles.desktop)}>
        {!hideBanner && renderBanner()}
        <Layout>
          <Layout.Sider>
            <Menu />
          </Layout.Sider>
          <Layout>
            <Layout.Content>
              <div className={styles.body}>
                {fullContent && fullBody ? (
                  <div className={styles.full}>
                    <div className={styles.top}>
                      <div className={styles.left}>{leftHeader}</div>
                      <div className={styles.right}>{rightHeader}</div>
                    </div>
                    {fullBody}
                  </div>
                ) : (
                  <>
                    <div className={styles.left}>
                      <div className={styles.top}>{leftHeader}</div>
                      {leftBody}
                    </div>
                    <div className={styles.right}>
                      <div className={styles.top}>{rightHeader}</div>
                      {rightBody}
                    </div>
                  </>
                )}
              </div>
            </Layout.Content>
          </Layout>
        </Layout>
      </div>
    );
  };

  const renderMobileView = () => {
    return (
      <div id={id} className={styles.wrapper}>
        <div
          className={classNames(styles.header, {
            [styles.hasBorder]: !progress && hasBorder,
            [styles.hasProgress]: progress
          })}
        >
          <TitleHeading
            title={title}
            subTitle={subTitle}
            onBack={onBack}
            onClose={onClose}
            rightIcons={rightIcons}
            hideMenu={hideMenu}
            center={center}
            progress={progress}
            onFavouriteAction={onFavouriteAction}
            isFavourite={isFavourite}
          />
        </div>
        <div
          className={styles.content}
          {...(usingModal && { id: "modal-body-content" })}
        >
          {!hideBanner && renderBanner()}
          {children}
        </div>
        {footer && (
          <div className={styles.footer}>
            <div className={styles.footerOpacity} />
            {footer}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderMobileView()}</MobileView>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  isAccountPendingReview: selectors.isAccountPendingReview(state),
  showEmailSuggestionBanner: selectors.isShowEmailSuggestionBanner(state),
  features: selectors.getFeatures(),
  hasToken: selectors.hasToken(state)
});

export default connect(mapStateToProps)(MainLayout);
